import { MouseEvent } from 'react';
import Trash from 'components/icons/trash';
import ButtonIcon from 'components/ButtonIcon';
import { Llmtestinput } from 'data/firestore/agent/llmtestinput/types';
import {
    StyledLi,
    StyledOption,
    OptionName,
} from './styled';

interface Props {
    input: Llmtestinput;
    onClick?: (input: Llmtestinput) => void;
    onDelete?: (id: string) => void;
}

const Option = ({
    input, onClick = () => {}, onDelete = () => {},
}: Props) => {
    const handleDelete = (e: MouseEvent) => {
        e.stopPropagation();
        onDelete(input.id);
    };

    return (
        <StyledLi onClick={() => onClick(input)}>
            <StyledOption role="option">
                <OptionName>
                    {input.title}
                </OptionName>
                <ButtonIcon icon={<Trash />} size="small" onClick={handleDelete} />
            </StyledOption>
        </StyledLi>
    );
};

export default Option;
